/*
 * PaginationManager Module
 * Paginate a list and trigger event when page is changed
 */

const PaginationManager = (function() {
    // ================== VARIABLE ================== //
    var _callbacks = [];

    var _result_by_page = 12;
    var _current_page;
    var _maxPage;
    var _pages = [];

    // ================== CONSTRUCTOR ================== //
    function PaginationManager() {
        // Singleton
        if (PaginationManager.instance) {
            throw new Error('PaginationManager is a singleton. Use PaginationManager.instance.');
        }
        // enforces new
        if (!(this instanceof PaginationManager)) {
            return new PaginationManager();
        }
        window.goToPage = _goToPage;
        window.prevPage = _prevPage;
        window.nextPage = _nextPage;
    };

    // ================== PUBLIC METHOD ================== //
    PaginationManager.prototype.paginateResult = function(cruise_list, page) {
        _checkPagination(cruise_list, page);
        return _pages[_current_page];
    };

    PaginationManager.prototype.onPageChange = function(callback, target) {
        _callbacks.push({
            'callback': callback,
            'target': target
        });
    };

    // ================== PRIVATE METHOD ================== //

    function _checkPagination(cruise_list, page) {
        // Clear old pagination
        _hidePagination();
        _pages = [];
        // Check for pagination
        if (cruise_list.length > _result_by_page) {
            // Create The pages (list of _list_to_display)
            _maxPage = ((cruise_list.length - 1) / _result_by_page | 0) + 1;
            _current_page = page > 0 ? (page < _maxPage ? (page - 1) : _maxPage - 1) : 1;
            _showPagination();
            _displayPrevNext();
            for (var pageNb = 0; pageNb < _maxPage; pageNb++) {
                _pages[pageNb] = [];
                for (var i = pageNb * _result_by_page; i < Math.min((pageNb + 1) * _result_by_page, cruise_list.length); i++) {
                    _pages[pageNb].push(cruise_list[i]);
                }
            }
        } else {
            _current_page = 0;
            _pages[_current_page] = [];
            for (var i = 0; i < cruise_list.length; i++) {
                _pages[_current_page].push(cruise_list[i]);
            }
        }
    };

    function _showPagination() {
        $('.pagination-container').show();
        $('#page-number-container').append('<span id="prev-span" onclick="prevPage()" class="previous"><i class="fa fa-angle-left"></i></span>');
        for (var i = 0; i < _maxPage; i++) {
            $('#page-number-container').append('<span id="page-' + i + '" onclick="goToPage(' + (i + 1) + ')" class="page-number' + (i == _current_page ? ' page-active' : '') + '">' + (i + 1) + '</span>');
        }
        $('#page-number-container').append('<span id="next-span" onclick="nextPage()" class="next"><i class="fa fa-angle-right"></i></span>');
    }

    function _hidePagination() {
        $('.pagination-container').hide();
        $('#page-number-container').html('');
    }

    function _updatePage () {
        _displayPrevNext();
        _pageChange();
        $('html').animate({scrollTop:0}, 500);
    }

    function _displayPrevNext() {
        $('#prev-span').removeClass('disabled');
        $('#next-span').removeClass('disabled');
        if (_current_page == 0)
            $('#prev-span').addClass('disabled');
        if (_current_page == _maxPage - 1)
            $('#next-span').addClass('disabled');
    }

    function _pageChange() {
        var page = _pages[_current_page];
        for (var i = 0; i < _callbacks.length; i++) {
            _callbacks[i].callback.apply(_callbacks[i].target, [page]);
        }
    }

    function _goToPage(page_nb) {
        $("[name='page']").val(page_nb);
        if (page_nb != _current_page) {
            $('#page-' + _current_page).removeClass('page-active');
            _current_page = page_nb;
            $('#page-' + _current_page).addClass('page-active');
            _updatePage();
        }
    }

    function _prevPage() {
        if (_current_page > 0) {
            $('#page-' + _current_page).removeClass('page-active');
            _current_page -= 1;
            $('#page-' + _current_page).addClass('page-active');
            $("[name='page']").val(_current_page + 1);
            _updatePage();
        }
    }

    function _nextPage() {
        if (_current_page < _maxPage - 1) {
            $('#page-' + _current_page).removeClass('page-active');
            _current_page += 1;
            $('#page-' + _current_page).addClass('page-active');
            $("[name='page']").val(_current_page + 1);
            _updatePage();
        }
    }

    function _compareCruise(a, b) {
        var r = a.duration - b.duration;
        if (r == 0)
            return a.id - b.id;
        return r
    }


    PaginationManager.instance = new PaginationManager();

    return PaginationManager.instance;
})();

export default PaginationManager



// WEBPACK FOOTER //
// ./search/static/search/js/paginationManager.js